import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const ProtectedRoute = ({ children }) => {
    const { user, isLoading } = useAuth();

    if (isLoading) {
        return <p>Ładowanie...</p>;
    }

    return user ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
